module.exports = __webpack_public_path__ + "static/media/file-upload.dfc1d08c.svg";